import { ExportUtil, AttributeExportFieldEditor, AttributeExportFieldModel, AttributeDetailEditor, AttributeColumnEditor } from '@leverege/ui-attributes';
import AttributeEnumEditor from "./AttributeEnumEditor.js";
import EnumDetailModel from "./EnumDetailModel.js";
import EnumDetailRenderer from "./EnumDetailRenderer.js";
import ExportFieldTypeCreator from "../ExportFieldTypeCreator.js";
import EnumColumnRenderer from "./EnumColumnRenderer.js";
import EnumColumnModel from "./EnumColumnModel.js";
import sortBySortValueAndStringField from "./sortByValueAndStringField.js";
import EnumCustomTextModel from "./EnumCustomTextModel.js";
import EnumCustomTextRenderer from "./EnumCustomTextRenderer.js";
function install(molten) {
  // columns
  molten.addPlugin('AttributeValueEditor', AttributeEnumEditor);
  molten.addPlugin('Model', {
    type: EnumColumnModel.TYPE,
    model: EnumColumnModel
  });
  molten.addPlugin('ModelEditor', {
    type: EnumColumnModel.TYPE,
    editor: AttributeColumnEditor
  });
  molten.addPlugin('ColumnRenderer', {
    type: EnumColumnModel.TYPE,
    renderer: EnumColumnRenderer
  });

  // export
  ExportFieldTypeCreator.create('enum').install(molten);
  const enumStrType = ExportUtil.getExportFieldTypeForType('enum');
  molten.addPlugin('Model', {
    type: enumStrType,
    model: AttributeExportFieldModel.createFor(enumStrType)
  });
  molten.addPlugin('ModelEditor', {
    type: enumStrType,
    editor: AttributeExportFieldEditor
  });
  molten.addPlugin('Model', {
    type: EnumCustomTextModel.TYPE,
    model: EnumCustomTextModel
  });
  molten.addPlugin('CustomTextValueRenderer', EnumCustomTextRenderer);

  // details
  molten.addPlugin('Model', {
    type: EnumDetailModel.TYPE,
    model: EnumDetailModel
  });
  molten.addPlugin('ModelEditor', {
    type: EnumDetailModel.TYPE,
    editor: AttributeDetailEditor
  });
  molten.addPlugin('DetailRenderer', {
    type: EnumDetailModel.TYPE,
    renderer: EnumDetailRenderer
  }); // eslint-disable-line

  // install sorters
  molten.addPlugin('EnumValueSorter', {
    type: 'sortValueAndStringField',
    sort: sortBySortValueAndStringField
  });
  molten.addPlugin('EnumValueSorter', {
    type: 'none',
    sort: (model, values) => values
  });
}
export default {
  install
};